
import { ShieldCheck, Zap, Clock } from "lucide-react";
import { useLanguage } from "@/components/LanguageContext";
import { useLanguagePath } from "@/utils/language";

interface BenefitCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const BenefitCard = ({ icon, title, description }: BenefitCardProps) => (
  <div className="bg-baby-powder dark:bg-gray-800 p-8 rounded-xl shadow-ios hover:shadow-md transition-shadow text-center">
    <div className="inline-block p-3 bg-flame/10 dark:bg-flame/20 text-flame rounded-full mb-4">{icon}</div>
    <h3 className="text-xl font-semibold mb-2 text-black dark:text-white">{title}</h3>
    <p className="text-slate-gray-dark dark:text-gray-300">{description}</p>
  </div>
);

export const Benefits = () => {
  const { t } = useLanguage();
  const { getPath } = useLanguagePath();
  
  return (
    <div id="benefits" className="py-24 bg-slate-gray-light/5 dark:bg-gray-800/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-black dark:text-white mb-4">
            {t('landing.benefits.title')}
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <BenefitCard
            icon={<ShieldCheck className="h-8 w-8" />}
            title={t('landing.benefits.security.title')}
            description={t('landing.benefits.security.description')}
          />
          <BenefitCard
            icon={<Zap className="h-8 w-8" />}
            title={t('landing.benefits.efficiency.title')}
            description={t('landing.benefits.efficiency.description')}
          />
          <BenefitCard
            icon={<Clock className="h-8 w-8" />}
            title={t('landing.benefits.availability.title')}
            description={t('landing.benefits.availability.description')}
          />
        </div>
      </div>
    </div>
  );
};
